import { useState, createContext, useContext, useCallback, useEffect } from "react";

import ConversationOptionsModal from "./ConversationOptionsModal";
import ShareModal from "./ShareModal";
import PostOptionsModal from "./PostOptionsModal";
import UserSelectModal from "./UserSelectModal";
import UserDisplayModal from "./UserDisplayModal";
import MediaFocusModal from "./MediaFocusModal";
import EventCreateForm from "./EventCreateForm";
import EventFocusModal from "./EventFocusModal";
import EventInviteInbox from "./EventInviteInbox";

const ModalContext = createContext();

export function useModal() {
  return useContext(ModalContext);
}

export function renderModal(modal, openModal, closeTopModal) {
  switch (modal.type) {
    // case "PostModal":
    //   return <PostModal {...modal.props} onClose={closeTopModal} openModal={openModal} />;
    case "ShareModal":
      return <ShareModal {...modal.props} onClose={closeTopModal} openModal={openModal} />;
    case "UserSelectModal":
      return <UserSelectModal {...modal.props} onClose={closeTopModal} openModal={openModal} />;
    case "UserDisplayModal":
      return <UserDisplayModal {...modal.props} onClose={closeTopModal} openModal={openModal} />;
    case "ConversationOptionsModal":
      return (
        <ConversationOptionsModal {...modal.props} onClose={closeTopModal} openModal={openModal} />
      );
    case "PostOptionsModal":
      return <PostOptionsModal {...modal.props} onClose={closeTopModal} openModal={openModal} />;
    case "MediaFocusModal":
      return <MediaFocusModal {...modal.props} onClose={closeTopModal} openModal={openModal} />;
    case "EventCreateForm":
      return <EventCreateForm {...modal.props} onClose={closeTopModal} />;
    case "EventFocusModal":
      return <EventFocusModal {...modal.props} onClose={closeTopModal} openModal={openModal} />;
    case "EventInviteInbox":
      return <EventInviteInbox {...modal.props} onClose={closeTopModal} openModal={openModal} />;

    default:
      return null;
  }
}

export function ModalBackdrop({ onClose, children, zIndex }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  // prevents background scrolling
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex }}
      onClick={onClose}
    >
      <button
        onClick={onClose}
        aria-label="Close"
        className="absolute top-2 right-2 z-[60] text-3xl text-black hover:text-black"
      >
        x
      </button>

      <div className="fixed inset-0 bg-black bg-opacity-50" />

      <div className="relative z-[50] w-full flex justify-center px-4 sm:px-6">{children}</div>
    </div>
  );
}

export function ModalProvider({ children }) {
  const [modalStack, setModalStack] = useState([]);

  const openModal = useCallback((type, props = {}) => {
    setModalStack((prev) => [...prev, { type, props }]);
  }, []);

  const closeTopModal = useCallback(() => {
    setModalStack((prev) => prev.slice(0, -1));
  }, []);

  const closeAllModals = useCallback(() => {
    setModalStack([]);
  }, []);

  const contextValue = {
    openModal,
    closeTopModal,
    closeAllModals,
  };

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
      {modalStack.map((modal, idx) => (
        <ModalBackdrop key={idx} onClose={closeTopModal} zIndex={9999 + idx}>
          {renderModal(modal, openModal, closeTopModal)}
        </ModalBackdrop>
      ))}
    </ModalContext.Provider>
  );
}
